// src/services/pricing.service.js
import { env } from "../config/env";
import { createClient } from "./http";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

const api = createClient(env.CATALOG_BASE_URL);

function authHeaders() {
  const token = getAuthToken?.() || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function normalizePrice(item = {}) {
  return {
    ...item,
    id: item?.id || item?._id || "",
    productId: item?.productId || item?.product_id || "",
    productVariantId: item?.productVariantId || item?.product_variant_id || "",
    warehouseId: item?.warehouseId || item?.warehouse_id || "",
    mrp: item?.mrp ?? null,
    sellingPrice: item?.sellingPrice ?? item?.selling_price ?? null,
    discountPercent: item?.discountPercent ?? item?.discount_percent ?? "",
    currency: item?.currency || "INR",
    active: item?.active ?? item?.is_active ?? true,
    effectiveFrom: item?.effectiveFrom || item?.effective_from || "",
    effectiveTo: item?.effectiveTo || item?.effective_to || "",
  };
}

export const pricingService = {
  async listPrices({ productId, productVariantId = "", warehouseId = "" } = {}) {
    if (!productId) throw new Error("productId is required");
    const params = { productId };
    if (productVariantId) params.productVariantId = productVariantId;
    if (warehouseId) params.warehouseId = warehouseId;
    const res = await api.get("/api/admin/prices", { params, headers: authHeaders() });
    const raw = res?.data ?? res ?? {};
    const items = Array.isArray(raw?.items) ? raw.items : Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
    return { ...raw, items: items.map(normalizePrice) };
  },
  async createPrice(payload) { return api.post("/api/admin/prices", payload, { headers: authHeaders() }); },
  async deactivatePrice(id) { if (!id) throw new Error("Price id is required"); return api.patch(`/api/admin/prices/${id}/deactivate`, {}, { headers: authHeaders() }); },
  async activatePrice(id) { if (!id) throw new Error("Price id is required"); return api.patch(`/api/admin/prices/${id}/activate`, {}, { headers: authHeaders() }); },
  async deletePrice(id) { if (!id) throw new Error("Price id is required"); return api.del(`/api/admin/prices/${id}`, { headers: authHeaders() }); },
  async listPurchaseHistory({ productId = "", warehouseId = "", batchNo = "", q = "", page = 1, limit = 20 } = {}) {
    const offset = Math.max(0, (Number(page) - 1) * Number(limit));
    const params = { limit, offset };
    if (productId) params.productId = productId;
    if (warehouseId) params.warehouseId = warehouseId;
    if (batchNo) params.batchNo = batchNo;
    if (q) params.q = q;
    return api.get("/api/admin/prices/purchase-history", { params, headers: authHeaders() });
  },
  async getPurchaseHistory(id) { if (!id) throw new Error("Purchase history id is required"); return api.get(`/api/admin/prices/purchase-history/${id}`, { headers: authHeaders() }); },
  async updatePurchaseHistory(id, payload) { if (!id) throw new Error("Purchase history id is required"); return api.patch(`/api/admin/prices/purchase-history/${id}`, payload, { headers: authHeaders() }); },
  async deletePurchaseHistory(id) { if (!id) throw new Error("Purchase history id is required"); return api.del(`/api/admin/prices/purchase-history/${id}`, { headers: authHeaders() }); },
};
